export default function ({ showItems, items }) {
    return {
        showReviewItem: window.matchMedia('(max-width: 768px)').matches
            ? 2
            : showItems,
        isShowAllItems: false,
        init() {
            this.isShowAllItems = Number(items) > Number(this.showReviewItem);
        },
        buttonVisibility() {
            if (Number(items) > Number(this.showReviewItem)) {
                return true;
            }
            return false;
        },
        reviewVisibility(item) {
            if (!this.isShowAllItems) {
                return true;
            }

            if (item <= this.showReviewItem) {
                return true;
            } else {
                return false;
            }
        },
        itemLastVisible(item) {
            return item === this.showReviewItem;
        }
    };
}
